import { useEffect, useState } from 'react';
import PageBodyWrapper from '../components/PageBodyWrapper'
import { Paginator, SearchAndFilterToolbar } from '../components/common'
import PromoUsageTable from '../components/promocode-usage/PromoUsageTable'
import useApi from '../api'
import { useSearchParams } from 'react-router-dom'
import { handleRetriveError } from '../utils'


function PromocodeUsage() {
    const api = useApi()
    const [promoUsage, setPromoUsage] = useState<any>(null)
    const [searchParams, setSearchParams] = useSearchParams();

    const parseSearchParams = (params: URLSearchParams) => {
      const obj: { [key: string]: any } = {};
      params.forEach((value, key) => {
        obj[key] = value.includes(',') ? value.split(',') : value;
      });
      return obj;
    };

    const fetchPromocodeUsage = () => {
      const queryObject = parseSearchParams(searchParams);
      api.getPromoUsage(queryObject).then((response:any)=>{
        setPromoUsage(response)
      }, handleRetriveError)
    }

    useEffect(()=>{
      fetchPromocodeUsage()
    }, [searchParams])

    useEffect(() => {
      if (!searchParams.get("page")) {
        const newParams = new URLSearchParams(searchParams);
        newParams.set("page", "1");
        setSearchParams(newParams);
      };
    }, []);

    const onPageChange = (page: number | any) => {
      if (!page) {
        return;
      }
      const newParams = new URLSearchParams(searchParams);
      newParams.set("page", page.toString());
      setSearchParams(newParams);
    }

  return (
    <PageBodyWrapper>
        <SearchAndFilterToolbar
            onDateRangeApply={()=>null}
            onFilterOpen={()=>null}
        />
        <PromoUsageTable data={promoUsage?.results || []} />
        <Paginator data={promoUsage} onPageChange={onPageChange}/>

    </PageBodyWrapper>
  )
}

export default PromocodeUsage